define.alias("ember-math-helpers/helpers/hypot", "media/helpers/hypot");